import { commonAccountCompanyRequiredFieldList, CommonAccountConstant } from "presentation/constant/CommonAccount/CommonAccountConstant";
import { useCommonAccountVM } from "presentation/hook/CommonAccount/useCommonAccountVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useCommonAccountTracked } from "presentation/store/CommonAccount/CommonAccountProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useMemo } from "react";
import { FieldType, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const CommonAccountCompanyEditPanel = () => {
    const COMMON_ACCOUNT_CONSTANT = CommonAccountConstant.Table;
    const [commonAccountState] = useCommonAccountTracked();
    const commonAccountVM = useCommonAccountVM();
    const { isShowCompanyAddPanel, isShowCompanyEditPanel, currentCompanyEditRow, tempCompanyRows, masterState } = commonAccountState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();


    const handleSave = useCallback(async () => {

        if (tempCompanyRows?.some(e => e.billToCompany === currentCompanyEditRow.billToCompany
            && e.chargeOnCompany === currentCompanyEditRow.chargeOnCompany && e.id !== currentCompanyEditRow.id
        )) {
            messageBarVM.showError("Duplicate record found, please check the key: Charge On Company,  Bill To Company.");
            return;
        }

        commonAccountVM.onDtlSaveClicked();
        commonAccountVM.onCompanyTempSave(currentCompanyEditRow);
    }, [commonAccountVM, currentCompanyEditRow, messageBarVM, tempCompanyRows]);

    const handClose = useCallback(() => {
        commonAccountVM.onCloseCompanyEidtPanel();
    }, [commonAccountVM]);

    const handleReset = useCallback(() => {
        commonAccountVM.onResetCompanyEidtPanel(isShowCompanyAddPanel);
    }, [commonAccountVM, isShowCompanyAddPanel]);

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        commonAccountVM.onCompanyFieldChange(fieldName, fieldValue);
    }, [commonAccountVM]);

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState ?? ""}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={''}
                fieldValue={currentCompanyEditRow?.billToCompany ?? ''}
                fieldLabel={COMMON_ACCOUNT_CONSTANT.BILL_TO_COMPANY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompany'}
                maxLength={60}
                isLimitOptions={true}
                options={commonAccountState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={commonAccountCompanyRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    commonAccountVM.onCompanyFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [currentCompanyEditRow?.billToCompany, COMMON_ACCOUNT_CONSTANT.BILL_TO_COMPANY, allFormState, isSaveClicked, commonAccountState.dynamicOptions.companyCodeDropdownOptions, commonAccountVM])

    const memoChargeOnCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState ?? ""}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={''}
                fieldValue={currentCompanyEditRow?.chargeOnCompany ?? ''}
                fieldLabel={COMMON_ACCOUNT_CONSTANT.CHARGE_ON_COMPANY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeOnCompany'}
                maxLength={60}
                isLimitOptions={true}
                options={commonAccountState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={commonAccountCompanyRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    commonAccountVM.onCompanyFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [currentCompanyEditRow?.chargeOnCompany, COMMON_ACCOUNT_CONSTANT.CHARGE_ON_COMPANY, allFormState, isSaveClicked, commonAccountState.dynamicOptions.companyCodeDropdownOptions, commonAccountVM])

    const memoPercentage = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={COMMON_ACCOUNT_CONSTANT.PERCENTAGE}
                maxLength={6}
                fieldName={"percentage"}
                value={currentCompanyEditRow.percentage ?? ''}
                errorMessage={allFormState ? allFormState["percentage"] : ""}
                disabled={false}
                decimalPlaces={2}
                isPercentage={false}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [COMMON_ACCOUNT_CONSTANT.PERCENTAGE, allFormState, currentCompanyEditRow.percentage, onNumberFieldChange])


    return <>
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
                        <Sidebarheader style={{ width: '100%' }}>
                            <SidebarTitle>
                                {isShowCompanyAddPanel && "New Common Account Company"}
                                {isShowCompanyEditPanel && "Edit Common Account Company"}
                            </SidebarTitle>
                            <SidebarActionCross>
                                <>
                                    <IconButton fileName="Icon-reset" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={() => handleReset()} />
                                    <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                                    <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />
                                </>
                            </SidebarActionCross>

                        </Sidebarheader>

                    </StyledSidebar>
                </div>
            </div>
            <div className={'add-edit-form'} style={{ height: '78vh', maxHeight: '78vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        <CriteriaItemContainer>
                            {memoBillToCompany}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoChargeOnCompany}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoPercentage}
                        </CriteriaItemContainer>


                    </div>
                </div>
            </div>

        </div>
    </>
}

export default memo(CommonAccountCompanyEditPanel);
